// ── Orchestrator ──────────────────────────────────────────────────────────────

import type { PostFeedingReportMessageDto } from "@strtmn/sds/types"
import {
  buildFeedingsDetailsSheet,
  buildFeedingsSummarySheet,
  buildVerbrauchSummarySheet,
} from "./excel"
import { fetchAllDetails } from "./fetchDetails"
import type { FeedingSummaryRow, VerbrauchStats } from "./types"

async function downloadXlsx(wb: any, filename: string): Promise<void> {
  const buf = await wb.xlsx.writeBuffer()
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export async function runFeedingsExport(
  summaryRows: FeedingSummaryRow[],
  fetchDetail: (id: string) => Promise<PostFeedingReportMessageDto>,
  onProgress: (done: number, total: number) => void,
  signal: AbortSignal
): Promise<void> {
  const { Workbook } = await import("exceljs")

  const results = await fetchAllDetails(
    summaryRows,
    fetchDetail,
    signal,
    (done) => onProgress(done, summaryRows.length)
  )

  if (signal.aborted) {
    return
  }

  const wb = new Workbook()
  wb.creator = "Strautmann SDS"
  wb.created = new Date()

  buildFeedingsSummarySheet(wb, summaryRows, results)
  buildFeedingsDetailsSheet(wb, summaryRows, results)

  await downloadXlsx(
    wb,
    `feedings-${new Date().toISOString().slice(0, 10)}.xlsx`
  )
}

export async function runVerbrauchExport(stats: VerbrauchStats): Promise<void> {
  const { Workbook } = await import("exceljs")

  const wb = new Workbook()
  wb.creator = "Strautmann SDS"
  wb.created = new Date()

  buildVerbrauchSummarySheet(wb, stats)

  await downloadXlsx(
    wb,
    `verbrauch-${new Date().toISOString().slice(0, 10)}.xlsx`
  )
}
